import { render, staticRenderFns } from "./r-select-option.vue?vue&type=template&id=7a2da7f5&scoped=true"
import script from "./r-select-option.vue?vue&type=script&setup=true&lang=js"
export * from "./r-select-option.vue?vue&type=script&setup=true&lang=js"
import style0 from "./r-select-option.vue?vue&type=style&index=0&id=7a2da7f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2da7f5",
  null
  
)

export default component.exports